import {HttpRequest} from "../utils/httpRequest";

let UdUser = {
    /**
     * 获取数据
     * @param datas
     * @returns {*}
     */
    getUdUser(datas) {
        return HttpRequest.getRequest({
            method: 'get',
            url: '/edu/user/list',
            data: datas
        });
    },

    /**
     * 获取所有用户
     * @returns {*}
     */
    getUserList() {
        return HttpRequest.getRequest({
            url: '/edu/user/all',
            method: 'get'
        });
    },

    getUserInfo(id) {
        return HttpRequest.getRequest({
            method: 'get',
            url: '/edu/user/info/' + id,
        })
    },

    /**
     * 添加或修改数据
     * @param type
     * @param datas
     */
    addOrUpdateUser(type, datas) {
        return HttpRequest.getRequest({
            method: 'post',
            url: '/edu/user/' + type,
            data: datas
        });
    },
    /**
     * 删除数据
     * @param datas
     */
    deleteUser(datas) {
        return HttpRequest.getRequest({
            method: 'get',
            url: '/edu/user/delete',
            data: datas
        });
    }
};
export {UdUser}
